import { types } from '../../types/types';

export const initialState = {
	companyLoaded: "",
	footerDocuments: "",
	users: [],
	services: [],
	civilstates: [],
	medicalplanes: [],
	educationlevels: [],
	genders: [],
	chatCustomerCare: [],
	chatProfessional: [],
	usersMobile: [],
	permissions: [],
	permissionsRoutes: {},
	permissionsIntegrations: {},
	tagsManager: {},
	professionalMobile: [],
	companyInstance: null,
	resources: null
}

export const companyReducer = (state = initialState, action) => {

	switch (action.type) {

		case types.addUser:
			return {
				...state,
				users: [action.payload, ...state.users]
			}

		case types.usersLoad:
			return {
				...state,
				users: [
					...action.payload
				]
			}

		case types.usersClean:
			// return initialState
			/**
				Se retorna de esta forma el state para que no se borren las instancias de la BD 
				una vez cierre sesión y aún permanezca en la URL de la company 
			*/
			return {
				...state,
				users: [],
				services: [],
				civilstates: [],
				medicalplanes: [],
				educationlevels: [],
				genders: [],
				chatCustomerCare: [],
				chatProfessional: [],
				usersMobile: [],
				permissions: [],
				professionalMobile: [],
			}

		case types.userUpdated:
			return {
				...state,
				users: state.users.map(
					users => users.id === action.payload.id
						? action.payload.users
						:
						users
				)
			}

		case types.loadServices:
			return {
				...state,
				services: action.payload
			}

		case types.clearServices:
			return {
				...state,
				services: []
			}

		case types.loadCivilStates:
			return {
				...state,
				civilstates: action.payload
			}

		case types.clearCivilStates:
			return {
				...state,
				civilstates: []
			}

		case types.loadMedicalPlanes:
			return {
				...state,
				medicalplanes: action.payload
			}

		case types.clearMedicalPlanes:
			return {
				...state,
				medicalplanes: []
			}

		case types.loadEducationLevels:
			return {
				...state,
				educationlevels: action.payload
			}

		case types.clearEducationLevels:
			return {
				...state,
				educationlevels: []
			}

		case types.loadGenders:
			return {
				...state,
				genders: action.payload
			}

		case types.clearGenders:
			return {
				...state,
				genders: []
			}

		case types.loadChatProfessional:
			return {
				...state,
				chatProfessional: action.payload
			}

		case types.clearChatProfessional:
			return {
				...state,
				chatProfessional: []
			}

		case types.loadChatCustomer:
			return {
				...state,
				chatCustomerCare: action.payload
			}

		case types.clearChatCustomer:
			return {
				...state,
				chatCustomerCare: []
			}

		case types.loadUsersMobile:
			return {
				...state,
				usersMobile: action.payload
			}

		case types.clearUsersMobile:
			return {
				...state,
				usersMobile: []
			}
		case types.loadProfessionalMobile:
			return {
				...state,
				professionalMobile: action.payload
			}

		case types.clearProfessionalMobile:
			return {
				...state,
				professionalMobile: []
			}

		case types.loadCompanyPermissions:
			return {
				...state,
				permissions: action.payload
			}

		case types.clearCompanyPermissions:
			return {
				...state,
				permissions: []
			}

		case types.loadedCompany:
			return {
				...state,
				companyLoaded: action.payload
			}

		case types.loadCompanyDocumentFooter:
			return {
				...state,
				footerDocuments: action.payload
			}

		case types.clearLoadedCompany:
			return {
				...state,
				companyLoaded: ""
			}

		case types.clearLoadedDocumentFooter:
			return {
				...state,
				footerDocuments: ""
			}
		case types.loadCompanyPermissionsRoutes:
			return {
				...state,
				permissionsRoutes: action.payload
			}

		case types.clearCompanyPermissionsRoutes:
			return {
				...state,
				permissionsRoutes: {}
			}

		case types.loadCompanyPermissionsIntegrations:
			return {
				...state,
				permissionsIntegrations: action.payload
			}

		case types.clearCompanyPermissionsIntegrations:
			return {
				...state,
				permissionsIntegrations: {}
			}

		case types.loadCompanyTagsManager:
			return {
				...state,
				tagsManager: action.payload
			}

		case types.clearCompanyTagsManager:
			return {
				...state,
				tagsManager: {}
			}

		case types.loadCompanyResources:
			return {
				...state,
				resources: action.payload
			}

		case types.clearCompanyResources:
			return {
				...state,
				resources: {}
			}

		case types.companyInstance:
			return {
				...state,
				companyInstance: action.payload
			}

		case types.clearCompanyInstance:
			return {
				...state,
				companyInstance: null
			}

		default:
			return state
	}


}